// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesNeo4jDatabaseSizes
 */
export interface TypesNeo4jDatabaseSizes {
  /**
   *
   * @type {string}
   * @memberof TypesNeo4jDatabaseSizes
   */
  lastUpdate?: string;
  /**
   *
   * @type {number}
   * @memberof TypesNeo4jDatabaseSizes
   */
  systemBytes?: number;
  /**
   *
   * @type {number}
   * @memberof TypesNeo4jDatabaseSizes
   */
  userBytes?: number;
}

/**
 * Check if a given object implements the TypesNeo4jDatabaseSizes interface.
 */
export function instanceOfTypesNeo4jDatabaseSizes(
  value: object,
): value is TypesNeo4jDatabaseSizes {
  return true;
}

export function TypesNeo4jDatabaseSizesFromJSON(
  json: any,
): TypesNeo4jDatabaseSizes {
  return TypesNeo4jDatabaseSizesFromJSONTyped(json, false);
}

export function TypesNeo4jDatabaseSizesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesNeo4jDatabaseSizes {
  if (json == null) {
    return json;
  }
  return {
    lastUpdate: json['LastUpdate'] == null ? undefined : json['LastUpdate'],
    systemBytes: json['SystemBytes'] == null ? undefined : json['SystemBytes'],
    userBytes: json['UserBytes'] == null ? undefined : json['UserBytes'],
  };
}

export function TypesNeo4jDatabaseSizesToJSON(
  json: any,
): TypesNeo4jDatabaseSizes {
  return TypesNeo4jDatabaseSizesToJSONTyped(json, false);
}

export function TypesNeo4jDatabaseSizesToJSONTyped(
  value?: TypesNeo4jDatabaseSizes | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    LastUpdate: value['lastUpdate'],
    SystemBytes: value['systemBytes'],
    UserBytes: value['userBytes'],
  };
}
